<template>
  <div>
    <b-table
      hover
      small
      head-variant="dark"
      :items="items"
      :fields="fields">
      <template v-slot:cell(index)="data">
        {{data.index + 1}}
      </template>
      <template v-slot:cell(createdAt)="data">
        {{data.value | humanize}}
      </template>
      <template v-slot:cell(actions)="data">
        <div class="text-right">
          <b-button
            variant="outline-primary"
            size="sm"
            class="px-2 mr-1"
            @click="$emit('edit', data.item.id)">
            <i class="fa fa-pencil"/>
          </b-button>

          <b-button
            variant="outline-danger"
            size="sm"
            class="px-2 mr-1"
            @click="$emit('delete', data.item.id)">
            <i class="fa fa-trash-o"/>
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
  export default {
		name: 'ListView',

    props: {
		  items: Array
    },

    computed: {
      fields() {
        return [
          {key: 'index', label: '#'},
          {key: 'name', label: 'Name'},
          {key: 'group', label: 'Group'},
          {key: 'createdAt', label: 'Created'},
          {key: 'actions', label: ''},
        ];
      },
    },
	};
</script>

<style scoped>

</style>
